export enum PERIODS_TYPE_ENUM_ES {
  BIWEEKLY_PERIOD = 'Catorcenas',
  MONTHLY_PERIOD = 'Meses',
  SEMIMONTHLY_PERIOD = 'Quincenas',
  WEEKLY_PERIOD = 'Semanas'
}
